import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {ServiceAreasServiceType} from "../../../service-areas/angular/types/service-areas-service.type";

export class BringozServiceAreaSelectListCtrl implements IController {
  options: any;
  optionIds: string[];
  selectedId: any;
  ngPlaceholder: any;
  serviceTypes: ServiceAreasServiceType[];
  excludeIds: any;
  branchIds:any;
  onChange: Function;


  private serviceAreasRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;
  private selectedKeys: any;
  public excludedMap: any;

  /* @ngInject */
  constructor(private $serviceArea, private $infiniteScroll, private $log) {
  }

  $onInit() {
    this.serviceAreasRef = this.$serviceArea();
    if (!this.options) {
      this.loadLimit = 20;
      this.serviceAreasRef.$query(this._getQueryPayload());
      this.infiniteScroll = this.$infiniteScroll(this.serviceAreasRef, this.loadLimit, {getFullData: true});
    } else {
      this.loadLimit = 0;
      this.infiniteScroll = this.$infiniteScroll(this.serviceAreasRef, this.loadLimit, {ignoreFetch: true});
      this.infiniteScroll.addItems(this.options);
    }
  }

  $onChanges(changes) {
    if (changes.excludeIds) {
      this.excludedMap = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludedMap[id] = true;
      })
    }
  }

  submitQuery(query) {
    this.queryString = query;
    if (!this.optionIds) {
      this._reload();
    } else {
      this._search();
    }
  }

  private _reload() {
    this.serviceAreasRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _search() {
    this.infiniteScroll.search(this.queryString);
  }

  private _getQueryPayload() {
    return {
      ids: this.optionIds,
      limit: this.loadLimit,
      query: this.queryString,
      branchIds: this.branchIds,
      serviceTypes: this.serviceTypes,
      sort: 'areaName,asc'
    };
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozServiceAreaSelectList', {
    bindings: {
      options: '<?',
      optionIds: '<?',
      selectedId: '<',
      ngPlaceholder: '@?',
      serviceTypes: '<?',
      excludeIds: '<?',
      branchIds: '<?',
      onChange: '&'
    },
    template: require('./bringoz-service-area-select-list.html').default,
    controller: BringozServiceAreaSelectListCtrl
  });
